import { Context } from '@leverege/plugin';
import { cancelRingTag } from '../../util/Interface';
function isRingableTag(item) {
  switch (item?.type) {
    case 'tag':
      return item.data?.data?.commands?.ring?.state === 'waitingForDetection';
    case 'key':
      return item.data?.data?.tag && item.data.data.tag.data?.commands?.ring?.state === 'waitingForDetection';
    default:
      return false;
  }
}
export default {
  id: 'recovr.tag.CancelRing',
  name: 'Cancel Ring Tag',
  layout: {
    sort: 'z.ring.zcancel',
    sectionName: 'Ring'
  },
  matches: [{
    use: ['contextMenu', 'mobileActionBar'],
    path: ['tag', 'location.tags', 'company.tags', 'company.locations.tags', 'key', 'location.keys', 'company.keys', 'company.locations.keys'],
    objectType: ['tag', 'key']
  }, {
    client: 'MapBoxRolloverSelectionPointer',
    use: ['contextMenu', 'mobileActionBar']
  }],
  handles: cxt => {
    const targets = Context.getTargets(cxt);
    if (targets.length === 1 && isRingableTag(targets[0])) {
      return true;
    }
    return false;
  },
  appearance: ({
    context
  }) => {
    const name = 'Cancel Ring Tag';
    return {
      name,
      icon: 'fa fa-bell-slash'
    };
  },
  perform: data => {
    const {
      context
    } = data;
    const targets = Context.getTargets(context);
    const reloadData = context?.clientProps?.reloadData;
    const tag = targets[0].type === 'tag' ? targets[0].data : targets[0].data.data.tag;
    cancelRingTag({
      systemId: tag.systemId,
      companyId: tag.data.company?.id,
      locationId: tag.data.location?.id,
      deviceId: tag.id
    }, reloadData);
  }
};